import React from 'react';
import {Link} from 'react-router-dom';
import AccessShell from './AccessShell';
import './WelcomePage.css';

export default function WelcomePage(){
 return <AccessShell wide className="sy-welcome">
  <section className="sy-welcome-hero" aria-labelledby="welcome-title">
   <p className="sy-welcome-eyebrow">İLİM · SOHBET · İRFAN</p>
   <h1 id="welcome-title">İrfana açılan<br/><em>sakin bir kapı.</em></h1>
   <p className="sy-welcome-intro">Sohbet, eser ve Kur’an okumalarıyla<br/> Sayyâdi Sanal Dergâh’a hoş geldiniz.</p>
   <div className="sy-access-actions">
    <Link className="sy-access-button sy-access-primary" to="/giris">Giriş Yap <span aria-hidden="true">↗</span></Link>
    <Link className="sy-welcome-apply" to="/giris?basvuru=1">Üyelik Başvurusu <span aria-hidden="true">→</span></Link>
   </div>
   <p className="sy-welcome-membership">Üyelere özel · Yönetici onayıyla erişim</p>
  </section>
  <section className="sy-welcome-discover" aria-label="Sayyâdi’de sizi bekleyenler">
   {[
    ['01','Sohbet','Sohbet ve video arşivi'],
    ['02','Kütüphane','Eserler ve kaynak katalogları'],
    ['03','Yolculuk','Kur’an ve okuma araçları']
   ].map(([number,title,text])=><article key={title}><span className="sy-welcome-number" aria-hidden="true">{number}</span><div><h2>{title}</h2><p>{text}</p></div></article>)}
  </section>
  <details className="sy-welcome-details">
   <summary>Üyelik ve içerikler hakkında</summary>
   <div>
    <p>Üyelik başvurunuzu oluşturun; yönetici incelemesinin sonucunu aynı giriş yöntemiyle hesabınızdan takip edin. Belirlenmiş bir onay süresi yoktur. Özel içerikler yalnız onaylanan üyelere, hesaplarının erişim izinleriyle açılır.</p>
    <p>Sohbetleri, eser kataloglarını ve fizikî kitapların raf konumlarını keşfedin. Kur’an okuyucusunda Türkçe sûre adları, kaynaklı Türkçe meal ve ayet seçimiyle okuyun. Kişisel kayıtlarınızı ve duyuruları takip edin.</p>
    <p>Otomatik transkriptler ayrıca kalite incelemesinden geçer. Katalog kaydı tam metin onayı anlamına gelmez. Kaynaklı AI cevap hizmetinde doğrulama çalışmaları sürüyor; onaylı kanıt bulunmadan kesin veya kaynaklı cevap vaat edilmez.</p>
   </div>
  </details>
 </AccessShell>;
}
